import { __awaiter } from "tslib";
/**
 * 组件使用场景：成交
 * */
import React, { Component } from 'react';
import { notification, Modal, Form, Input, Icon } from 'antd';
import ReactDOM from 'react-dom';
import { dispatch } from '@@/store';
import { CHECK_name } from '@/shared/reqexp';
class RecallApprove extends Component {
    constructor(props) {
        super(props);
        this.afterClose = () => {
            this.props.form.resetFields();
        };
        this.state = {
            show: false,
            selectData: {},
        };
        this.cancel = this.cancel.bind(this);
        this.handleOK = this.handleOK.bind(this);
    }
    cancel() {
        this.setState({
            show: false,
            selectData: {},
        });
        this.callback = undefined;
    }
    handleOK() {
        this.props.form.validateFields()
            .then((formData) => {
            const { selectData } = this.state;
            dispatch.approve.recallApprove({
                goodsId: selectData.goodsId,
                remark: formData.remark,
                callback: () => {
                    this.callback && this.callback();
                    this.setState({
                        show: false,
                    });
                },
            });
        })
            .catch((err) => {
            const reason = err.values.reason;
            notification.error({
                message: '提交失败',
                description: reason === '' ? <div>请填写相关带<span style={{ color: 'red' }}>*</span>必填</div> : '限制100字符',
            });
        });
    }
    show(selectData, callback) {
        this.setState({
            show: true,
            selectData,
        });
        callback && (this.callback = callback);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { show } = this.state;
        return (<Modal closable={false} onOk={this.handleOK} onCancel={this.cancel} afterClose={this.afterClose} visible={show}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
        }}>
          <Icon type="exclamation-circle" theme="filled" style={{
            color: '#F9BF32',
            fontSize: 30,
            marginRight: 10,
        }}/>
          撤回提醒
        </div>
        <div style={{
            marginLeft: 40,
        }}>
          <div style={{
            margin: '10px 0',
        }}>
            车辆已审批成功，撤回审批后车辆即下线
          </div>
          <Form.Item colon={false}>
            {getFieldDecorator('remark', {
            rules: [
                {
                    required: true,
                    message: '请输入撤回原因',
                },
                {
                    validator: CHECK_name(100),
                    message: '限100字符',
                },
            ],
        })(<Input.TextArea placeholder="请输入撤回原因（必填，100字符内）" autoSize={{
            minRows: 4,
            maxRows: 4,
        }}/>)}
          </Form.Item>
        </div>
      </Modal>);
    }
}
RecallApprove.defaultProps = {};
const RecallApproveComponent = Form.create()(RecallApprove);
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    componentRef = React.createRef();
    const component = (<>
      <RecallApproveComponent wrappedComponentRef={componentRef}/>
    </>);
    ReactDOM.render(component, div);
};
export default function recallApprove(data, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!componentRef) {
            yield createAbortiveAuction();
        }
        console.log(componentRef);
        componentRef.current.show(data, callback);
    });
}
